<template>
    <the-header></the-header>
    <div id="subscription"></div>
    <div id="left-bottom-sticky-container"></div>
</template>

<script>
import TheHeader from '@/components/commonHeader.vue'

export default {
    components: {
        TheHeader
    },
    mounted() {
        window.tp?.push(["init", () => {
            window.tp?.experience.execute()
        }]);
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            const sticky = document.getElementById('left-bottom-sticky-container')
            const scrollTop = window.scrollY
            const width = window.innerWidth
            if (!sticky) return
            if (scrollTop > 300) {
                if (width > 1200) {
                sticky.style.bottom = '30px'
                } else if (width > 1000 && width <= 1200) {
                sticky.style.bottom = '12px'
                } else if (width > 600 && width <= 1000) {
                sticky.style.bottom = '0px'
                } else if (width <= 600) {
                sticky.style.bottom = '0px'
                } else {
                sticky.style.bottom = '30px'
                }
            } else {
                sticky.style.bottom = '-100%'
            }
        }
    }
}
</script>
<style>
    #left-bottom-sticky-container {
        position: fixed;
        bottom: -100%;
        left: 35px;
        width: 100%;
        max-width: 800px;
        height: auto;
        z-index: 11;
        display: block;
        transition: all .8s;
    }
    @media screen and (max-width: 570px) {
        #left-bottom-sticky-container {
            left: 0;
            width: 100%;
            bottom: 0;
        }
    }
    @media screen and (max-width: 1000px) and (min-width: 571px) {
        #left-bottom-sticky-container {
            left: 0;
            width: 100%;
            max-width: 100%;
        }
    }
    @media screen and (max-width: 1180px) and (min-width: 1001px) {
        #left-bottom-sticky-container {
            bottom: -100%;
            left: 12px;
            transform: unset;
        }
    }
</style>